import "assets/fonts/fonts.css";
import "components/common/Form/form-datepicker.css";
import "normalize.css";
import { setConfiguration } from "react-grid-system";
import { createGlobalStyle } from "./index";
import { ITheme } from "./theme.types";

// Declare breakpoints as a enum so it can be used in media queries
export enum Breakpoints {
  xs = 768,
  sm = 1024,
  md = 1280,
  lg = 1440
}

const theme: ITheme = {
  color: {
    primary: "#0c2b51",
    primaryTransparent: "rgba(17, 38, 68, 0.85)",
    secondary: "#c7dff5",
    tertiary: "#abc658",
    secondaryTransparent: "rgba(214, 233, 246 , 0.80)",
    white: "#FAFAFA",
    red: "#FF697C",
    gray: { light: "#eaeae7", medium: "#91928e", dark: "#54667f" }
  },
  fontFamily: {
    black: "Avenir-Heavy, sans-serif",
    bold: "Avenir-Heavy, sans-serif",
    light: "Avenir-Light, sans-serif",
    regular: "Avenir, sans-serif"
  },
  fontSize: {
    l: "6.8vh",
    m: "4.6vh",
    ms: "3.2vh",
    s: "2.4vh",
    body: "2.8vh",
    buttons: "2.6vh",
    headings: {
      hero: "8vh",
      h1: "6.5vh",
      h2: "5.4vh",
      h3: "4.5vh",
      h4: "3.2vh",
      h5: "2.6vh",
      small: "2.2vh"
    }
  },
  global: {
    headerHeight: 17,
    radius: "0.3rem",
    shadow: "0 1px 7px 0 rgba(0, 0, 0, 0.11)",
    transition: "all 200ms ease-in-out",
    nudge: 2,
    gutter: 1.2,
    containerWidths: [960, 960, 1140, 1280],
    keyboard: {
      keyHeight: "6vh"
    }
  }
};

export default theme;

export const GlobalStyle = createGlobalStyle`
  html {
    font-size: 62.5%;
    overflow: hidden;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
  }
  #root {
    height: 100%;
  }

  .ReactModal__Body--open {
    overflow: hidden;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
  }

  body {
    font-family: ${theme.fontFamily.regular}, 'AlternateGotNo3DRegular', sans-serif;
    font-size: ${theme.fontSize.body};
    color: ${theme.color.primary};
    background-color: ${theme.color.white};
    background-size: cover;
    /* Disables pull-to-refresh but allows overscroll glow effects. */
    overscroll-behavior-y: none;

  }
  html, body{
    overflow: hidden;
    position: relative;
    height: 100%;
  }
  a {
    text-decoration: none;
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fontFamily.bold};
    color: ${theme.color.primary};
  }
  p {
    margin: ${theme.global.gutter}rem 0;
  }
    
  `;

// Set grid configuration
// See: https://github.com/JSxMachina/react-grid-system#configuration
setConfiguration({
  breakpoints: [Breakpoints.xs, Breakpoints.sm, Breakpoints.md, Breakpoints.lg],
  containerWidths: theme.global.containerWidths,
  gutterWidth: theme.global.gutter * 10
});



// WEBPACK FOOTER //
// ./src/themes/simple-theme-vh.ts